import React from 'react';
import { Tabs } from 'antd';
import 'styles/ant-design.css';
import { useTranslation } from 'react-i18next';
import { getTabs } from 'components/features/peer-review/peer-review-tabs/types';

interface PeerReviewTabProps {
  activeTab: string;
  onTabChange: (key: string) => void;
}

const PeerReviewTab: React.FC<PeerReviewTabProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation();
  const tabs = getTabs(t);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={tabs}
      className="custom-tabs-with-bottom-curve"
    />
  );
};

export default PeerReviewTab;
